// Confetti-style ray burst on every successful add-to-cart.
//
// HOW IT WORKS
// WooCommerce fires `added_to_cart` on document.body whenever its AJAX
// add-to-cart succeeds (loop buttons everywhere; CheckoutWC routes single
// product forms through the same event). One listener here spawns a burst of
// brand-colored rays flying out of whichever button was clicked - so any
// current or future add-to-cart button gets the animation with no extra code.
//
// The burst host is position:fixed on <body>, anchored to the button's
// viewport center, because buttons often sit inside overflow:hidden cards
// that would clip the rays. It removes itself when the animation is over.
// Styling/keyframes live in scss/base/_cart-burst.scss.

const RAY_COUNT = 10;
const BURST_LIFETIME = 800; // longest ray animation + safety margin

/**
 * Center of the button's ::before icon. Pseudo-elements have no DOM node, so
 * measure the label (a range over the button's real children) and step left
 * across the flex gap; buttons without an icon burst from their center.
 */
function burstOrigin(button) {
    const rect = button.getBoundingClientRect();
    const icon = window.getComputedStyle(button, '::before');
    const iconWidth = parseFloat(icon.width);

    if (icon.content === 'none' || !iconWidth) {
        return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    }

    const range = document.createRange();
    range.selectNodeContents(button);
    const label = range.getBoundingClientRect();
    const gap = parseFloat(window.getComputedStyle(button).columnGap) || 0;

    return { x: label.left - gap - iconWidth / 2, y: rect.top + rect.height / 2 };
}

function burst(button) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const origin = burstOrigin(button);
    const host = document.createElement('span');
    host.className = 'son-cart-burst';
    host.style.left = `${origin.x}px`;
    host.style.top = `${origin.y}px`;

    for (let i = 0; i < RAY_COUNT; i++) {
        const ray = document.createElement('i');
        // even spread with a little jitter, so it reads as sparks, not a clock
        ray.style.setProperty('--angle', `${(i * 360) / RAY_COUNT + (Math.random() * 16 - 8)}deg`);
        ray.style.setProperty('--distance', `${26 + Math.random() * 14}px`);
        host.appendChild(ray);
    }

    document.body.appendChild(host);
    setTimeout(() => host.remove(), BURST_LIFETIME);
}

// listen on document (not body): the bundle loads in <head> before <body>
// exists, and Woo's body event bubbles up to document anyway
jQuery(document).on('added_to_cart', (event, fragments, cartHash, $button) => {
    // Woo passes the clicked button; fall back to the single product button
    // for add paths that don't (e.g. ajaxified PDP form submits).
    const button = $button && $button.length ? $button[0] : document.querySelector('.single_add_to_cart_button');
    if (button) {
        burst(button);
    }
});
